
import React, { useState, useEffect, useContext, createContext, Component } from 'react';
import { Link } from 'react-router-dom';
import serialize from 'form-serialize';
import axios from 'axios';

import {api_path} from '../../../server.js'; 
import logo from '../../../logo.png'


function RecuperarSenha() {

  const [email_codigo, setEmail_codigo] = useState('');
  const [email, setEmail] = useState('');
  const [codigorecebido, setCodigorecebido] = useState('');
  const [s1, setS1] = useState('');
  const [s2, setS2] = useState('');
  const [codsended, setCodSended] = useState('NAO');
  const [alterado, setAlterado] = useState('NAO');
  const [txt_codigoenviado, setTxt_codigoenviado] = useState('');
  const [txt_codigoenviadomsg, setTxt_codigoenviadomsg] = useState('');
  const [txt_codigoenviadoerro, setTxt_codigoenviadoerro] = useState('');
  const [txt_codigoenviadoemailcliente, setTxt_codigoenviadoemailcliente] = useState('');
  
  function enviaCodigo(e){

    const form = e.currentTarget;
    let dados= serialize(form, {hash: true, empty: true})
    const bodyDadosProp = { acao: 'enviacodigo', dados}
    //field_s1
        axios.post(api_path()+'sistema/cliente.login.php', bodyDadosProp, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
            let emailcliente = response.data.emailcliente;
            let msg = response.data.msg;
            let erro = response.data.erro;
            setTxt_codigoenviadomsg(msg);
            setTxt_codigoenviadoerro(erro);
            setTxt_codigoenviadoemailcliente(emailcliente);
          })
          .catch(function (response) {

          });
          return;
}

function handleSubmitCodigo(e){
    e.preventDefault();
    var varMail = e.target.email_codigo.value;

    if(varMail==""){
      alert("Digite o email cadastrado.");
      setEmail_codigo('');
      setCodigorecebido('');
    }else{
      enviaCodigo(e);
    }
}


function alteraSenha(e){
  const form = e.currentTarget;
  let dados=serialize(form, {hash: true, empty: true})
  const bodyDadosProp = { acao: 'recuperacaoSenhaAlterar', dados}
      axios.post(api_path()+'sistema/cliente.login.php', bodyDadosProp, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then((response) => {
          let erro = response.data.ERRO;
          let msg = response.data.MENSAGEM;

          if(erro==="NAO"){
            setAlterado('SIM');
          }
          alert(msg);
        })
        .catch(function (response) {
              //handle error
              //console.log(response);
        });
}


function handleSubmitSenha(e){
  e.preventDefault();
  alteraSenha(e);
}




  return (

    <div class="grid-container form-signin account-wall">
      

            {alterado==="NAO" &&
            <div>
                <form name="enviacodigo" id="enviacodigo" onSubmit={handleSubmitCodigo}>
                  <div className="grid-x grid-padding-x">
                    <div className="large-12 small-12 medium-12 cell">
                      <img className="profile-img" src={logo} alt=""/>
                    </div>
                    <div className="large-12 small-12 medium-12 cell"><h3>Recuperar Senha</h3></div>
                    <div className="large-12 small-12 medium-12 cell">
                      <input type="text" name="email_codigo" value={email_codigo} onChange={(e) => setEmail_codigo(e.target.value)} placeholder="Digite seu email" required/>
                    </div>
                    <div className="large-12 small-12 medium-12 cell">
                      <button type="submit" class="button secondary float-right">Enviar</button>
                    </div>
                  { txt_codigoenviadoerro==="NAO" &&
                    <div className="large-12 small-12 medium-12 cell">Foi <strong>enviado um codigo</strong>  para o email {txt_codigoenviadoemailcliente}</div>
                  }
                  { txt_codigoenviadoerro==="SIM" &&
                    <div className="large-12 small-12 medium-12 cell">{txt_codigoenviadomsg}</div>
                  }
                    <div className="large-12 small-12 medium-12 cell">{txt_codigoenviado}</div>
                  </div>
                </form>
                
                <hr/>

              <form name="formsenha" id="formsenha" onSubmit={handleSubmitSenha}>
                <div className="grid-x grid-padding-x">
                  <input type="hidden" name="email" value={email_codigo} onChange={(e) => setEmail(e.target.value)} required/>
                  <div className="large-12 small-12 medium-12 cell">
                    <input type="text" name="codigorecebido" value={codigorecebido} onChange={(e) => setCodigorecebido(e.target.value)} placeholder="Codigo recebido" required/>
                    <input type="text" name="s1" value={s1} onChange={(e) => setS1(e.target.value)} placeholder="Digite sua nova senha" required/>
                    <input type="text" name="s2" value={s2} onChange={(e) => setS2(e.target.value)} placeholder="Confirme sua nova senha" required/>
                    <button type="submit" class="button secondary float-right">Alterar Senha</button>
                  </div>
                  <div className="large-12 small-12 medium-12 cell">
                    <Link to="../" className="float-right">Voltar</Link>
                  </div>
                </div>
              </form> 

            </div>
            }
            {alterado==="SIM" &&
            <div>
              <div className="grid-x grid-padding-x">
                <div className="large-12 small-12 medium-12 cell">
                  Senha alterada com sucesso!
                </div>
                <div className="large-12 small-12 medium-12 cell">
                  <Link to="../">Voltar</Link>
                </div>
              </div>
            </div>
            }


      
    </div>

  );
}

export default RecuperarSenha;
